/**
 * Audio URL utilities
 */

import { resolveMediaUrl } from './mediaUrl';

/**
 * Constructs full audio URL from relative or absolute path
 * @param audioUrl - The audio URL (can be relative, absolute, or blob URL)
 * @returns Full URL with STATIC_BASE_URL prepended if needed
 */
export const getFullAudioUrl = (audioUrl: string): string => {
  return resolveMediaUrl(audioUrl);
};
